

export const getLeftPivot = (blocks) => {
    if (blocks == [] || !blocks) {
        console.log(blocks)
        return;
    }
    return blocks.reduce((prev, current) => (prev && prev.x < current.x) ? prev : current).x;
};

export const getRightPivot = (blocks) => {
    if (blocks == [] || !blocks) {
        console.log(blocks)
        return;
    }
    return blocks.reduce((prev, current) => (prev && prev.x > current.x) ? prev : current).x;
};

export const getUpPivot = (blocks) => {
    if (blocks == [] || !blocks) {
        console.log(blocks)
        return;
    }
    return blocks.reduce((prev, current) => (prev && prev.y < current.y) ? prev : current).y - 40;
};

export const getBottomPivot = (blocks) => {
    if (blocks == [] || !blocks) {
        console.log(blocks)
        return;
    }
    let block = blocks.reduce((prev, current) => (prev && prev.y > current.y) ? prev : current);
    let res = block.y;
    if (block.id && block.type && block.type.id === 4) {
        res += 60;
    }
    return res;
};

export const getWidth = (blocks) => {
    const minimalSize = 400;
    const res = getRightPivot(blocks) - getLeftPivot(blocks) + minimalSize;
    return res;
};

export const getHeight = (blocks) => {
    let res = getBottomPivot(blocks) - getUpPivot(blocks);
    if (res !== 0) {
        res += 120;
    }
    return res;
};

export const getTransformByBlocks = (blocks) => {

    if (blocks.length === 0 || !blocks) {
        const transform = {
            x: 0,
            y: 0
        };
        return transform;
    }

    let upPivot = getUpPivot(blocks);
    let leftPivot = getLeftPivot(blocks);

    const transform = {
        x: leftPivot - 120,
        y: upPivot - 15
    };

    return transform;
    //categoryElement.style.transform = "translate3d("+ transform.x +"px,"+ transform.y +"px,"+ 0 + "px)";
}